import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AjaxService } from 'src/app/service/ajax.service';
import { AuthService } from 'src/app/service/auth.service';
import { UtilService } from 'src/app/service/util.service';
import { API } from 'src/environments/environment';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit, OnDestroy {

  public pergunta: string;
  public resposta: string;
  public status: boolean;
  public ordem: number;
  public programaSelecionado: any;

  public arrayFaqs: any[];
  public arrayProgramas: any[];
  public faqSelecionado: any;
  public mostrarFormulario: boolean = false;

  constructor(
    private router: Router,
    private ajax: AjaxService,
    public util: UtilService,
    private auth: AuthService
  ) {
    this.status = true;
    this.ordem = 1;
  }

  ngOnInit() {
    this.buscarFaqs();
    this.buscarProgramas();
  }

  ngOnDestroy(): void {
  }

  buscarFaqs() {
    this.util.showLoading();
    let url = API + "FAQ/FAQ";
    
    return this.ajax.get(url).subscribe(
      response => {
        this.arrayFaqs = response.data;
        console.log('FAQs carregados:', this.arrayFaqs);
        this.util.closeLoading();
      },
      err => {
        this.util.closeLoading();
        this.util.toasterShowError("Atenção", "Erro ao Buscar FAQs");
        console.log('Erro ao carregar FAQs:', err);
      }
    );
  }

  buscarProgramas() {
    this.util.showLoading();
    let url = API + "Programa/Programa";
    return this.ajax.get(url)
      .subscribe(response => {
        this.arrayProgramas = this.util.convertIoptions(response.data, "iD_PROGRAMA", "descricao");
        this.util.closeLoading();
      }, err => {
        this.util.closeLoading();
        this.util.toasterShowError("Atenção", "Erro ao Buscar Programas");
      });
  }

  validar() {
    if (this.pergunta == undefined || this.pergunta == "") {
      this.util.toasterShowError("Atenção", "Entre com a Pergunta");
      return false;
    }

    if (this.resposta == undefined || this.resposta == "") {
      this.util.toasterShowError("Atenção", "Entre com a Resposta");
      return false;
    }

    if (this.ordem == undefined || this.ordem == 0) {
      this.util.toasterShowError("Atenção", "Entre com a Ordem");
      return false;
    }

    return true;
  }

  abrirFormulario() {
    this.limpar();
    this.mostrarFormulario = true;
  }

  fecharFormulario() {
    this.mostrarFormulario = false;
    this.limpar();
  }

  limpar() {
    this.pergunta = "";
    this.resposta = "";
    this.status = true;
    this.ordem = 1;
    this.programaSelecionado = null;
    this.faqSelecionado = null;
  }

  salvar() {
    if (this.validar()) {
      this.util.showLoading();
      
      let dados: any = {
        "PERGUNTA": this.pergunta,
        "RESPOSTA": this.resposta,
        "STATUS": this.status ? true : false,
        "ORDEM": this.ordem
      };

      // Adiciona ID_PROGRAMA se foi selecionado
      if (this.programaSelecionado && this.programaSelecionado != "") {
        dados["ID_PROGRAMA"] = this.programaSelecionado;
      }

      let url = API + "FAQ/FAQ";
      return this.ajax.post(url, dados)
        .subscribe(response => {
          this.util.closeLoading();
          this.util.toasterShowSuccess("Sucesso", "FAQ Salvo com Sucesso");
          this.fecharFormulario();
          this.buscarFaqs();
        }, err => {
          this.util.closeLoading();
          this.util.toasterShowError("Atenção", "Erro ao Salvar FAQ");
        });
    }
  }

  alterar() {
    if (this.validar()) {
      this.util.showLoading();
      
      let dados: any = {
        "ID_FAQ": this.faqSelecionado.iD_FAQ,
        "PERGUNTA": this.pergunta,
        "RESPOSTA": this.resposta,
        "STATUS": this.status ? true : false,
        "ORDEM": this.ordem
      };

      // Adiciona ID_PROGRAMA se foi selecionado
      if (this.programaSelecionado && this.programaSelecionado != "") {
        dados["ID_PROGRAMA"] = this.programaSelecionado;
      }

      let url = API + "FAQ/FAQ";
      return this.ajax.post(url, dados)
        .subscribe(response => {
          this.util.closeLoading();
          this.util.toasterShowSuccess("Sucesso", "FAQ Atualizado com Sucesso");
          this.fecharFormulario();
          this.buscarFaqs();
        }, err => {
          this.util.closeLoading();
          this.util.toasterShowError("Atenção", "Erro ao Atualizar FAQ");
        });
    }
  }

  carregarItem(item) {
    this.faqSelecionado = item;
    this.pergunta = item.pergunta;
    this.resposta = item.resposta;
    this.status = item.status == 1;
    this.ordem = item.ordem;
    this.programaSelecionado = item.iD_PROGRAMA;
    this.mostrarFormulario = true;
  }

  desabilitar(id: number) {
    if (confirm('Deseja realmente remover este FAQ?')) {
      this.util.showLoading();
      
      let dados = {
        "ID_FAQ": id
      };
      
      let url = API + "FAQ/FAQ/Desabilitar";
      return this.ajax.post(url, dados)
        .subscribe(response => {
          this.util.closeLoading();
          this.util.toasterShowSuccess("Sucesso", "FAQ Desabilitado com Sucesso");
          this.buscarFaqs();
        }, err => {
          this.util.closeLoading();
          this.util.toasterShowError("Atenção", "Erro ao Desabilitar FAQ");
        });
    }
  }

}

